import type { LabelData } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export type MtMessagePageFormValues = {
  message?: string;
  file?: File | string;
};

export interface MtMessagePageConversationData {
  id: number;
  name: string;
  image?: string;
  label?: LabelData;
  hasUnseenMessages: boolean;
}

export interface MtMessagePageMessageData {
  id: number;
  isOwn: boolean;
  time: string;
  file?: string;
  text?: string;
  seen?: boolean;
  seenAt?: string;
}

export interface MtMessagePageMessageSectionData {
  title: string;
  isToday?: boolean;
  messages: MtMessagePageMessageData[];
}

export interface MtMessagesPageData {
  loading?: boolean;
  messageError?: boolean;
  onDeleteMessage?: (id: number) => void;
  onDeleteConversation?: (id: number) => void;
  onConversationClick?: (index: number) => void;
  onImageClick?: (url: string) => void;
  otherAccountIsDeleted: boolean;
}

export interface MtMessagesPageProps extends MtMessagesPageData {
  conversations: MtMessagePageConversationData[];
  currentConversation: MtMessagePageConversationData;
  messageSections: MtMessagePageMessageSectionData[];
  mobileMessagesShown: boolean;
  mobileOnBackClick?: MouseEventHandler;
}
